import { MouseEvent, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AlertMessage, { AlertLevel } from "../../components/AlertMessage";
import Password from "../../components/input/Password";
import { ResetPasswordViewModel, useResetPasswordMutation } from "./accountApiSlice";

export default function ResetPassword() {
	const [queryParams] = useSearchParams();
	const token = queryParams.get("token") ?? "";

	const [username, setUsername] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [confirmPassword, setConfirmPassword] = useState<string>("");
	const [error, setError] = useState<string>();

	const [resetPassword, resetPasswordResult] = useResetPasswordMutation();

	const navigate = useNavigate();

	function handleReset(e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>): void {
		e.preventDefault();
		const model = UpdateResetModel();

		if (model) {
			resetPassword(model)
				.unwrap()
				.then(() => {
					console.log("Password reset successfully.");
				})
				.catch((error) => {
					console.log(error);
					setError(error.data.errorMsg);
					scrollTo(0, 0);
				});
		}
	}

	function UpdateResetModel(): ResetPasswordViewModel {
		const model: ResetPasswordViewModel = {
			username: username,
			password: password,
			confirmPassword: confirmPassword,
			token: token,
		};
		return model;
	}

	return (
		<div>
			<h1 className="pt-8">Reset Password</h1>

			{!token ? (
				<div>
					<p className="mt-6">
						Your password cannot be reset because there is information missing from your
						URL.
					</p>
					<p className="mt-6">
						Please{" "}
						<a
							className="hover:underline hover:underline-offset-2 hover:cursor-pointer"
							onClick={() => navigate("/login")}>
							click here
						</a>{" "}
						to return to the login page.
					</p>
				</div>
			) : !resetPasswordResult.isSuccess && token ? (
				<div>
					<AlertMessage
						className="mt-8"
						type={AlertLevel.Error}
						message={error}
						showIcon={true}
						onClear={() => setError(undefined)}
					/>

					<form className="max-w-96">
						<div>
							<label
								htmlFor="username"
								className="block mt-6 font-medium leading-6 text-gray-900">
								Username
							</label>
							<div className="mt-2">
								<input
									type="text"
									name="username"
									id="username"
									required
									onChange={(e) => setUsername(e.target.value)}
									className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
								/>
							</div>
						</div>

						<div>
							<label
								htmlFor="new-password"
								className="block mt-6 font-medium leading-6 text-gray-900">
								New Password
							</label>
							<div className="mt-2">
								<Password
									id="new-password"
									name="new-password"
									placeholder="new password"
									required={true}
									className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
									onChange={(e) => setPassword(e.target.value)}
									value={password ?? ""}
								/>
							</div>
						</div>

						<div>
							<label
								htmlFor="confirm-password"
								className="block mt-6 font-medium leading-6 text-gray-900">
								Confirm Password
							</label>
							<div className="mt-2">
								<Password
									id="confirm-password"
									name="confirm-password"
									placeholder="confirm password"
									required={true}
									className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
									onChange={(e) => setConfirmPassword(e.target.value)}
									value={confirmPassword ?? ""}
								/>
							</div>
						</div>

						<button
							type="submit"
							className="btn btn-primary mt-6"
							onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleReset(e)}>
							Reset
						</button>
					</form>
				</div>
			) : (
				<p className="mt-4">
					Your password has been reset. Please{" "}
					<a
						className="hover:underline hover:underline-offset-2 hover:cursor-pointer"
						onClick={() => navigate("/login")}>
						click here
					</a>{" "}
					to login.
				</p>
			)}
		</div>
	);
}
